module.exports = __webpack_public_path__ + "img/female_resultF.687d54ae.png";